import { EventCard } from "../components/event-card";
import { StateMessage } from "../components/state-message";
import { stripMarkdownLinks } from "@repo/markdown";
import { truncateText } from "../lib/text";
import type { ViewProps } from "./types";

const AGENDA_DESCRIPTION_MAX_CHARS = 160;

export function AgendaView({
  config,
  events,
  isLoading,
  isLoadingMore,
  errorMessage,
  nextUrl,
  onSelect,
  onLoadMore,
}: ViewProps) {
  const cardConfig = { ...config, showLocation: false };
  const displayEvents = events.map((event) => ({
    ...event,
    description: truncateText(
      stripMarkdownLinks(event.description),
      AGENDA_DESCRIPTION_MAX_CHARS,
    ),
  }));

  return (
    <>
      {isLoading ? <StateMessage>Loading events…</StateMessage> : null}
      {!isLoading && errorMessage ? (
        <StateMessage variant="error">
          Unable to load events: {errorMessage}
        </StateMessage>
      ) : null}
      {!isLoading && !errorMessage && events.length === 0 ? (
        <StateMessage>No matching upcoming events.</StateMessage>
      ) : null}

      {!isLoading && !errorMessage && events.length > 0 ? (
        <div className="gitg-list gitg-list--agenda" aria-busy={isLoadingMore}>
          {displayEvents.map((event) => (
            <EventCard
              key={event.id}
              event={event}
              config={cardConfig}
              onSelect={onSelect}
            />
          ))}
        </div>
      ) : null}

      {!isLoading && !errorMessage && nextUrl ? (
        <div className="gitg-load-more">
          <button
            className="gitg-load-more-button"
            disabled={isLoadingMore}
            onClick={onLoadMore}
            type="button"
          >
            {isLoadingMore ? "Loading…" : "Load more"}
          </button>
        </div>
      ) : null}
    </>
  );
}
